import { render, staticRenderFns } from "./UsertypeIndex.vue?vue&type=template&id=5dc2c23a"
import script from "./UsertypeIndex.vue?vue&type=script&lang=js"
export * from "./UsertypeIndex.vue?vue&type=script&lang=js"
import style0 from "./UsertypeIndex.vue?vue&type=style&index=0&id=5dc2c23a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports